import EntrepreneurshipsAssignedTutor from '@/pages/tutor/EntrepreneurshipsAssigned.vue'
import EntrepreneurshipTasksTutor from '@/pages/tutor/EntrepreneurshipTasks.vue'
import EntrepreneurshipTasksModuleTutor from '@/pages/tutor/EntrepreneurshipTasksModule.vue'

import showStartUpTutor from '@/pages/tutor/show/showStartUp.vue'
import showStartUpTeamTutor from '@/pages/tutor/show/showTeam.vue'
import showStartupWindowTutor from '@/pages/tutor/show/showWindow.vue'

const tutorRoutes = [
  {
    path: '/tutor/entrepreneurships-assigned',
    name: 'EntrepreneurshipsAssignedTutor',
    component: EntrepreneurshipsAssignedTutor,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Emprendimientos asignados'
        }
      ]
    }
  },
  {
    path: '/tutor/entrepreneurships-assigned/:slug',
    name: 'EntrepreneurshipTasksTutor',
    component: EntrepreneurshipTasksTutor,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Emprendimientos asignados',
          to: { name: 'EntrepreneurshipsAssignedTutor'}
        },
        {
          text: 'Tareas'
        }
      ]
    }
  },
  {
    path: '/tutor/entrepreneurships-assigned/:slug/module/:module_pre_incubation_id/tasks',
    name: 'entrepreneurshipTasksModuleTutor',
    component: EntrepreneurshipTasksModuleTutor,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Emprendimientos asignados',
          to: { name: 'EntrepreneurshipsAssignedTutor'}
        },
        {
          text: 'Tareas',
          to: { name: 'EntrepreneurshipTasksTutor'}
        },
        {
          text: 'Ver',
        }
      ]
    }
  },
  {
    path: '/tutor/entrepreneurships-assigned/:slug/startup',
    name: 'showStartUpTutor',
    component: showStartUpTutor,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Emprendimientos asignados',
          to: { name: 'EntrepreneurshipsAssignedTutor'}
        },
        {
          text: 'Tareas',
          to: { name: 'EntrepreneurshipTasksTutor'}
        },
        {
          text: 'Ver StartUp',
        }
      ]
    }
  },
  {
    path: '/tutor/entrepreneurships-assigned/:slug/team',
    name: 'showStartUpTeamTutor',
    component: showStartUpTeamTutor,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Emprendimientos asignados',
          to: { name: 'EntrepreneurshipsAssignedTutor'}
        },
        {
          text: 'Tareas',
          to: { name: 'EntrepreneurshipTasksTutor'}
        },
        {
          text: 'Ver equipo',
        }
      ]
    }
  },
  {
    path: '/tutor/entrepreneurships-assigned/:slug/window',
    name: 'showStartupWindowTutor',
    component: showStartupWindowTutor,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Emprendimientos asignados',
          to: { name: 'EntrepreneurshipsAssignedTutor'}
        },
        {
          text: 'Tareas',
          to: { name: 'EntrepreneurshipTasksTutor'}
        },
        {
          text: 'Ver vidriera',
        }
      ]
    }
  }
]

export default tutorRoutes